import React, { useState, useEffect, useRef, useMemo, useContext } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

//Components
import { Header } from '../common/Header/Header';
import { ModalProduct } from '../Menu/ModalProduct';
import Btnquote from '../../utils/Btnquote';
import initData from './initData'
import validDomain from '../../utils/validDomain';
import ClientguestValid from '../../utils/ClientGuestValid';
import ReservationModal from '../Reservations/ReservationModal';
import { FaCalendarCheck } from 'react-icons/fa';
import moment from 'moment';
import { Menu } from '../Menu/Menu';
import { StatusMenu } from '../../api/StatusMenu';
import { AuthFetchAPI } from '../../api/Auth';
import { TablesFetchAPI } from '../../api/Tables';
import { BusinessFetchAPI } from '../../api/Business';
//Styles
import './Home.css';
import video_bg from '../../assets/video/PBW.mp4';
//utils 
import { RenderIf } from '../../utils/RenderIf';
import BannerBrand from '../Banner/BannerBrand';
import SmoothieSlider from '../SmoothieSlider/SmoothieSlider';
import background from '../SmoothieSlider/img/background.jpg'
import CategoryScroll from '../CategoryScroll/CategoryScroll';
import BlackHeader from './Headers/BlackHeader';
import CategoryInline from '../CategoryScroll/CategoryInline';
import Footer from './Footer';
import SectionRigth from './Sections/SectionRigth';
import SectionCenter from './Sections/SectionCenter';
import BannerCenter from './Sections/BannerCenter';
import BenefitCards from './Sections/BenefitCards ';
import resetStorage from '../../utils/resetStorage';
import GoToMenuCard from './Sections/GoToMenuCard';
import SubMenuNav from '../Menu/SubMenu/SubMenuNav ';
import HeaderMain from './Headers/HeaderMain';
import Loader from '../Home/Loader';
import { ProductContext } from '../../context/ProductContext';
import HeroSectionVideo from './Sections/HeroSectionVideo';
import HeroCarruselImg from './Sections/HeroCarruselImg';
import HeroSection from './Sections/HeroSection ';
import BtnShoppingcartFloat from '../../utils/BtnShoppingcartFloat';

import useSEO from '../../hooks/useSEO';
import { HeroStack } from './Sections/HeroStack';
import HeroSectionPlus from '../HeroSectionPlus/HeroSectionPlus';
import CategoryCarousel from '../CategoryCarousel/CategoryCarousel';
import WeeklyFavoritesSection from '../WeeklyFavoritesSection/WeeklyFavoritesSection';
import PromotionsPage from '../PromotionsPage/PromotionsPage';
import Layout from '../../layout/Layout';

// Bloques antiguos de promociones/recomendaciones (siempre d-none). No se montan para evitar descargar sus imágenes.
const LEGACY_HIDDEN_HOME_BLOCKS = false;

export const Home = () => {
   const { profile, order_code, quote } = useParams();
   const navigate = useNavigate();
   const [items, setItems] = useState()

   //const { business_code, branchoffice_code, machine_code_table } = useParams();
   const location = useLocation();
   const queryParams = new URLSearchParams(location.search);
   const menuType = queryParams.get('type');
   const [moduleCategories, setModuleCategories] = useState(true);
   const [moduleRecomendation, setModuleRecomendation] = useState(true);
   const [theme, setSetTheme] = useState("light");
   const [searchTerm, setSearchTerm] = useState('');
   const [temporalProducts, setTemporalProducts] = useState([]);

   const [businessCode, setbusinessCode] = useState(() => {
      if (localStorage.getItem("business") != "" && localStorage.getItem("business") != undefined) {
         return JSON.parse(localStorage.getItem("business")).code
      }
   });
   const [branchofficeCode, setBranchofficeCode] = useState(() => {
      if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined) {
         return JSON.parse(localStorage.getItem("branchoffice")).code
      }
   });

   const [clientData, setClientData] = useState(() => {
      if (localStorage.getItem('client') != null && localStorage.getItem('client') != undefined && localStorage.getItem('client') != '') {
         return JSON.parse(localStorage.getItem('client'))
      } else {
         return 0
      }
   })

   const [guestClient, setGuestClient] = useState(() => {
      if (localStorage.getItem('guestClient') != null && localStorage.getItem('guestClient') != undefined && localStorage.getItem('guestClient') != '') {
         return localStorage.getItem('guestClient')
      } else {
         return null
      }
   });

   // Context
   const { productData, setProductData } = useContext(ProductContext);

   //STATES MENU
   const [hero_section_data, sethero_section_data] = useState(0)
   const [benefit_cards_data, setbenefit_cards_data] = useState(0)
   const [banners_data, setbanners_data] = useState([])
   const [seoContent, setSeoContent] = useState(null)
   const [categories, setCategories] = useState([])
   const [favorites, setFavorites] = useState([])
   const [recomendation, setRecomendation] = useState([])
   const [promotions, setPromotions] = useState([])
   const [groups, setGroups] = useState([])
   const [allGroups, setAllGroups] = useState([])
   const [allfavorites, setAllFavorites] = useState([])
   const [reservations, setReservations] = useState(false)
   const [quoteMode, setQuoteMode] = useState(false)

   const [modalShow, setModalShow] = useState(false);
   const [selectedGroup, setSelectedGroup] = useState({});
   const [segmentsGroup, setSegmentsGroup] = useState([])

   const [shoppingcart, setShoppingcart] = useState([])
   const [shoppingCartCombos, setShoppingCartCombos] = useState([])

   const [showReservationModal, setShowReservationModal] = useState(false);

   //Filter the products by the term searched
   const filteredProducts = useMemo(() => {
      if (searchTerm === '') {
         return groups
      }
      return groups.filter(product => {

         const nameMatch = product.name.toLowerCase().includes(searchTerm.toLowerCase());
         const descriptionMatch = product.description.toLowerCase().includes(searchTerm.toLowerCase());
         const priceMatch = product.price.toString().toLowerCase().includes(searchTerm.toLowerCase());
         //return nameMatch || descriptionMatch || upc_code_match;
         return nameMatch || descriptionMatch || priceMatch;
      })
   }, [searchTerm, groups]);

   //Products shown in the "Destacados" home section, driven by the Recomendados config (fuente + límite)
   const recommendedProducts = useMemo(() => {
      const source = recomendation?.source;

      if (source === 'manual') {
         const skus = new Set(
            (recomendation?.items || [])
               .map(item => String(item.sku || '').trim())
               .filter(Boolean)
         );
         if (skus.size === 0) return [];
         return groups.filter(group =>
            (group.upc_codes || []).some(upc => skus.has(String(upc.upc_code || '').trim()))
         );
      }

      if (source === 'favorites') {
         return favorites;
      }

      // Legacy sources (bestsellers/new) kept for backward compatibility with older
      // saved configs, but there's no sales/creation-date data to rank by yet.
      return groups;
   }, [recomendation, favorites, groups]);

   //----------------------------auth params localstorage---------------------------------------------------
   let machine = "";
   let business = "";
   let branchoffice = "";
   let logo = ""
   let params = false
   let token = undefined
   if (localStorage.getItem('logo') != null || localStorage.getItem('logo') != undefined || localStorage.getItem('logo') != "") {
      logo = localStorage.getItem('logo')
   }
   if (localStorage.getItem("branchoffice") == "" || localStorage.getItem("branchoffice") == undefined || localStorage.getItem("machine") == "" || localStorage.getItem("machine") == undefined) {

   } else {
      params = true
      branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      //setBranchoffice(JSON.parse(localStorage.getItem('branchoffice')))
      machine = JSON.parse(localStorage.getItem('machine'));
      business = JSON.parse(localStorage.getItem("business"));
   }
   //---------------------------------------------------------------------------------------------------------
   const [frecuentShopperConfig, setFrecuentShopperConfig] = useState(() => {
      if (localStorage.getItem('frecuentShopperConfig') != null && localStorage.getItem('frecuentShopperConfig') != undefined && localStorage.getItem('frecuentShopperConfig') != '') {
         return JSON.parse(localStorage.getItem('frecuentShopperConfig'))
      } else {
         return null
      }
   })

   //----------------------Data general-----------------------\

   //function get day
   const getDayNow = () => {
      const today = new Date(); // Obtiene la fecha actual
      const dayOfWeek = today.getDay(); // Obtiene el día de la semana (0-6)

      // Mapeo de los días de la semana en inglés
      const daysInEnglish = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

      return daysInEnglish[dayOfWeek];
   };

   //function get interval time betwen catalog
   const filterByTimeRange = (array) => {
      const currentTime = moment(); // Obtiene la hora actual según la zona horaria

      return array.filter(({ minHour, maxHour }) => {
         const minTime = moment(minHour, 'HH:mm:ss'); // Convierte minHour a un objeto moment
         const maxTime = moment(maxHour, 'HH:mm:ss'); // Convierte maxHour a un objeto moment

         // Si el rango cruza la medianoche (por ejemplo, 23:30:00 a 02:00:00)
         if (maxTime.isBefore(minTime)) {
            return currentTime.isAfter(minTime) || currentTime.isBefore(maxTime);
         }

         // Si el rango no cruza la medianoche (por ejemplo, 00:00:00 a 03:00:00)
         return currentTime.isBetween(minTime, maxTime, null, '[)');
      });
   };

   //consolidates data into corresponding statements
   const dataconsolidation = async (generalData) => {
      if (generalData == 'error') {
         if (profile == "true") {
            navigate(`/profile`)
         } else {
            if (order_code !== undefined && order_code !== null) {
               navigate(`/branch/quote/${order_code}`)
            } else {
               navigate(`/branch`)
            }
         }
         return;
      }
      let data = generalData

      if (order_code !== undefined && order_code !== null) { navigate(`/order/quote/${order_code}`) }

      //section promotions---------------------------------------------------

      //filter promotion by status 1
      let dataPromotions = data.promotions

      let dataTemp = [];
      if (dataPromotions !== undefined && dataPromotions !== null && dataPromotions.length > 0) {
         dataPromotions.forEach((promotionNow) => {
            if (promotionNow.status == 1) {
               dataTemp.push(promotionNow)
            }
         })
      }

      setPromotions(dataTemp)

      //--------------------------------------------------------------------
      //section categories------------------------------------------------
      let dataGroups = data.groups
      //setGroups(groups_all)

      let categories_info = data.category
      //filter status available
      let catalogsavailable = data.catalogs && data.catalogs.length > 0 ? data.catalogs.filter(({ status }) => status === 1) : [];
      let dataday = getDayNow()
      // Filtra los catálogos que tienen el valor del día actual igual a 1
      let filterCatalogsDay = catalogsavailable && catalogsavailable.length > 0 ? catalogsavailable.filter((catalog) => catalog[dataday] === 1) : [];


      let catalogInTime = filterByTimeRange(filterCatalogsDay)


      if (catalogInTime.length > 0) {

         let catalogToCategories = []
         categories_info.forEach((category) => {
            let filter = catalogInTime[0].categories.find(({ category_id }) => category_id == category.category_id)
            if (filter != undefined) {
               catalogToCategories.push(category)
            }
         })

         setCategoriesShow(catalogToCategories)
      } else {
         setCategoriesShow(categories_info)
      }

      let categoriesDetails = []
      function setCategoriesShow(categoriesDetails) {

         let dataCategories = categoriesDetails
         let typeCodeCategories = 'P'
         let categoriesFilter = dataCategories && dataCategories.length > 0 ? dataCategories.filter(({ code, available_ecommerce }) => code === typeCodeCategories && available_ecommerce == 1) : [];
         setCategories(categoriesFilter)

         //safe all groups by categories
         let allgroupsByCategories = []
         categoriesFilter.forEach((categorie) => {
            allgroupsByCategories = allgroupsByCategories.concat(categorie.groups)
         })


         //Filter the groups that can be selled on ecommerce
         allgroupsByCategories = allgroupsByCategories.filter(({ available_ecommerce }) => available_ecommerce == 1)

         if (menuType == "points") {
            //filter the groups that can be paid with points
            allgroupsByCategories = allgroupsByCategories.filter(({ can_be_paid_with_points }) => can_be_paid_with_points == 1)
         } else {
            setAllGroups(allgroupsByCategories)
         }
         setGroups(allgroupsByCategories)


         //section favorites------------------------------------------------
         let dataFavoriteGroups = allgroupsByCategories.filter(({ favorite }) => favorite == 1)
         //filter the groups that can be paid with points
         if (menuType == "points") {
            dataFavoriteGroups = dataFavoriteGroups.filter(({ can_be_paid_with_points }) => can_be_paid_with_points == 1)
         } else {
            setAllFavorites(dataFavoriteGroups)
         }
         setFavorites(dataFavoriteGroups)

      }
      //---------------------------------------------------------------------
      //--------------------------DATA SHOPPINGCART-------------------------------------------

      if (localStorage.getItem('shoppingCart') == null || localStorage.getItem('shoppingCart') == undefined || localStorage.getItem('shoppingCart') == "") {
         setShoppingcart([])
      } else {
         let datashopingcart = JSON.parse(localStorage.getItem('shoppingCart'))
         setShoppingcart(datashopingcart)
      }

      if (localStorage.getItem('shoppingCartCombos') == null || localStorage.getItem('shoppingCartCombos') == undefined || localStorage.getItem('shoppingCartCombos') == "") {
         setShoppingCartCombos([])
      } else {
         let datashopingcart = JSON.parse(localStorage.getItem('shoppingCartCombos'))
         setShoppingCartCombos(datashopingcart)
      }


      //CONTENIDO
      if (data.ecommerce_content != null && data.ecommerce_content != undefined) {
         sethero_section_data(data.ecommerce_content.hero_section);
         setbenefit_cards_data(data.ecommerce_content.benefit_cards);
         setbanners_data(data.ecommerce_content.banners);
         setRecomendation(data.ecommerce_content.ui_config.recommended);
         setReservations(data.ecommerce_content.ui_config.reservations.enabled);
         //SEO content 
         setSeoContent(data.ecommerce_content?.head || null);
      }



      // Dentro de tu función dataconsolidation
      if (
         !clientData || // No hay cliente
         !clientData.id || // No hay id de cliente
         clientData.id === parseInt(guestClient) // Es cliente invitado
      ) {
         try {
            let response = await ClientguestValid();
            setClientData(response);
         } catch (err) {

         }
      }


      if (data.ecommerce_content != null && data.ecommerce_content != undefined) {
         if (data.ecommerce_content?.head?.icon) {
            localStorage.setItem('iconGeneral', data.ecommerce_content?.head?.icon.url)
         }

         //Ecommerce content
         let dataEcommerceContentUi = data.ecommerce_content.ui_config;
         setQuoteMode(dataEcommerceContentUi?.quotes?.enabled == true ? true : false)
         localStorage.setItem("quoteMode", dataEcommerceContentUi?.quotes?.enabled == true ? "true" : "false")
         setModuleCategories(dataEcommerceContentUi.categories.enabled);
         setModuleRecomendation(dataEcommerceContentUi.recommended.enabled);
         let themeInit = dataEcommerceContentUi.theme
         setSetTheme(themeInit);
         if (localStorage.getItem("theme") == null || localStorage.getItem("theme") == undefined || localStorage.getItem("theme") == "") {

            localStorage.setItem("theme", themeInit);
         }
      } else {
         /*if (localStorage.getItem("theme") == null || localStorage.getItem("theme") == undefined || localStorage.getItem("theme") == "") {
            localStorage.setItem("theme", "dark");
         }*/
      }


   }

   const selectCategorie = (categorie) => {
      localStorage.setItem('selectedCategorie', JSON.stringify(categorie))
      if (menuType == "points") {
         navigate(`/menu/?type=points`)
      } else {
         navigate(`/menu`)
      }
   }



   const selectProduct = (data) => {
      setProductData(data);
      setModalShow(true)
      setSelectedGroup(data)
      if (data.segments) {
         setSegmentsGroup(data.segments)
      } else {
         setSegmentsGroup([])
      }

      navigate(`/product`);
   }

   const selectPromotion = (data) => {
      data.name = data.promotion_name
      data.description = data.promotion_description
      data.group_type = "infinite";
      data.preparation = 0;
      setProductData(data);
      setSelectedGroup(data)
      if (data.segments) {
         setSegmentsGroup(data.segments)
      } else {
         setSegmentsGroup([])
      }
      setModalShow(true)
      navigate(`/product`);
   }

   //Function to initialize the data
   const handlerInit = async () => {
      try {
         resetStorage({
            frecuentShopperConfig: null,
            generalData: undefined,
         });
         let response = await validDomain();
         if (response !== undefined) {
            setbusinessCode(response);
            try {
               let response = await initData()
               dataconsolidation(response)
            } catch (err) {

            }
         } else {

            navigate(`/error`)
         }
      } catch (err) {
         console.log(err);
      }
   }



   useEffect(() => {
      handlerInit()
   }, [])

   useEffect(() => {
      if (menuType === 'points') {
         setGroups(groups.filter(group => group.can_be_paid_with_points === 1));
         setFavorites(favorites.filter(group => group.can_be_paid_with_points === 1));
      } else {
         setGroups(allGroups);
         setFavorites(allfavorites);
      }
   }, [menuType])


   const scrollRef = useRef(null);

   const scroll = (direction) => {
      const { current } = scrollRef;
      if (current) {
         current.scrollBy({ left: direction === 'left' ? -300 : 300, behavior: 'smooth' });
      }
   };




   //Information of ecommerce  - content

   const imageList = promotions.map(promo => promo.img);
   const [loading, setLoading] = useState(true);

   //SEO Inicial
   useSEO({

      title: "Inicio",
      bussines_name: business.name,
      description: "Bienvenido a " + business.name + ", explore nuestro menú y disfrute de una experiencia única.",
      icon: seoContent?.icon?.url || logo
   });

   return (
      <>
         {loading && <Loader logo={logo} onFinish={() => setLoading(false)} />}
         {!loading &&
            (<>
               <Layout>
                  <div>

                     {hero_section_data !== 0 ? <HeroSection hero_section={hero_section_data} /> : <></>}





                     {moduleCategories === true ? <>

                        {/* <CategoryScroll categories={categories} menuType={menuType} /> */}


                        <CategoryCarousel
                           categories={categories} menuType={menuType}
                        />


                     </> : <></>}



                     <RenderIf isTrue={recomendation?.enabled === true}>
                        <WeeklyFavoritesSection
                           products={recommendedProducts}
                           limit={recomendation?.limit}
                           title={recomendation?.description}
                           selectProduct={selectProduct}
                        />
                     </RenderIf>


                     {/* Bloques antiguos ocultos (d-none): no se montan para no descargar sus imágenes originales */}
                     {LEGACY_HIDDEN_HOME_BLOCKS && (promotions.length > 0 ? <>
                        <div className='d-none'>
                           <PromotionsPage promotions={promotions} onSelect={() => selectPromotion()} />
                        </div>
                        <div className='mb-4 positon-relative d-none'>
                           <div className="d-flex gap-1 overflow-auto py-1 ps-1">
                              {promotions.map((promotion) => (
                                 <>
                                    <div className="carousel-ecommerce-item " onClick={() => selectPromotion(promotion)}>
                                       <img src={promotion.img}
                                          className="d-block img-carrusel-ecommerce  bg-light shadow-sm" alt="..." />
                                    </div>
                                 </>
                              ))}
                           </div>
                        </div>

                     </> : <></>)
                     }

                     {/* 
                     {

                        banners_data.length != 0
                           ? <><HeroStack banners={banners_data[0] || []} />  </>
                           : <></>

                     } */}


                     {LEGACY_HIDDEN_HOME_BLOCKS && (
                     <div className='container mt-5 mb-5 category-item-enter d-none'>

                        {/* {moduleRecomendation === true ? <>{groups.length === 0 ? <></> : */}
                        <RenderIf isTrue={recomendation.enabled === true}>
                           <div className=' mt-5 category-item-enter container-offers p-0'>
                              <div className='row py-lg-4 ps-lg-5 py-1 ps-0'>

                                 <div className='col-md-4  justify-content-center align-items-center py-3 '>

                                    <div className='flex-column  rounded-4 h-100 align-items-center justify-content-center d-flex text-left p-3'>
                                       <div>
                                          <span className='display-4 fw-bold'>{recomendation?.description || "Nuestros clientes recomiendan"}</span>
                                       </div>
                                    </div>

                                 </div>
                                 <div className='col-md-8 rounded-4'>
                                    <div className="favorite-controls me-2">
                                       <div className="category-header w-100">
                                          <h2 className=''></h2>
                                          <div className="category-controls">
                                             <button className="scroll-btn" onClick={() => scroll('left')}><i class="uil uil-angle-left-b"></i></button>
                                             <button className="scroll-btn" onClick={() => scroll('right')}><i class="uil uil-angle-right-b"></i></button>
                                          </div>
                                       </div>
                                    </div>

                                    <div className="favorite-list no-scroll ps-lg-2 ps-3 pe-5" ref={scrollRef}>

                                       {groups.map((group, index) => (

                                          <>

                                             <div className="col-7 col-md-4"
                                                onClick={() => selectProduct(group)}
                                                key={index}
                                                role='button'
                                             >
                                                <div class="card food-card">
                                                   <div class="food-card-img">
                                                      <img src={group.img} alt="product" />
                                                   </div>
                                                   <div class="food-card-body">
                                                      <h3 class="food-title text-truncate">{group.name}</h3>
                                                      <p class="food-description">{group.description}</p>
                                                      <div class="food-footer">

                                                         <RenderIf isTrue={menuType != "points"}>
                                                            <span class="food-price"> ${group.price.toFixed(2)}</span>
                                                         </RenderIf>

                                                         <button class="add-btn" onClick={() => selectProduct(group)}>
                                                            <i class="bi bi-plus-lg"></i>
                                                         </button>
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                          </>
                                       ))}
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </RenderIf>
                        {/* }</> : <></>} */}
                     </div>
                     )}

                     {/* {

                     banners_data[1] != 0
                        ? <><HeroStack banners={banners_data[1] || []} />  </>
                        : <></>

                  } */}


                     {banners_data && banners_data[1]
                        ? (
                           <><HeroStack banners={banners_data[1] || []} />  </>
                        ) : <></>
                     }



                     < Footer />


                     {/** Reservation module */}

                     <RenderIf isTrue={reservations === true}>

                        <div

                           className='bq-trigger-fixed-2'
                        >
                           {/* ── TRIGGER BUTTON ── */}
                           <button
                              className="bq-trigger-2"
                              onClick={() => setShowReservationModal(true)}
                           >
                              <div className="bq-trigger-icon">
                                 <FaCalendarCheck />
                              </div>
                              <span className="bq-trigger-label">
                                 Reservar
                              </span>
                           </button>
                        </div>


                     </RenderIf>


                  </div>
               </Layout>

            </>)
         }


         {quoteMode == true && (<>
            <>
               <Btnquote />
            </>
         </>)}

         <ModalProduct
            modalShow={modalShow}
            setModalShow={setModalShow}
            selectedGroup={selectedGroup}
            segmentsGroup={segmentsGroup}
         />

         {/**Reservation modal */}
         <ReservationModal
            show={showReservationModal}
            onHide={() => setShowReservationModal(false)}
            businessCode={businessCode}
            branchofficeCode={branchofficeCode}
            clientData={clientData}
            token={token}
         />
      </>
   )
}
